import { useState, FC, useEffect } from "react";
import { UserPlus } from "lucide-react";
import { CompanyMember, User, Role } from "@vviinn/user-managment-client-ts";

import { companyUserRoles } from "./helpers";
import { RoleSelect } from "./RoleSelect";
import { NamedSelect } from "../../ui/layout/molecules/NamedSelect";
import { SlideOverWrapper } from "../../ui/layout/organisms/SlideOver/SlideOverWrapper/SlideOverWrapper";
import {
  SLIDEOVER_EDIT_ICON_ICON_STYLES,
  SLIDEOVER_EDIT_ICON_WRAPPER_STYLES,
} from "../../ui/layout/organisms/SlideOver/styles";
import { AcceptableWithTwoProps } from "../../helpers/functions/types";
import { Closeable } from "../../ui/layout/organisms/SlideOver/SlideOverWrapper/types";

export type InviteUserModalProps = {
  users: User[];
  companyMembers?: CompanyMember[];
};

export const InviteUserSlideOver: FC<
  React.PropsWithChildren<
    InviteUserModalProps & AcceptableWithTwoProps<string, Role> & Closeable
  >
> = ({ open, users, companyMembers, onClose, onAccept }) => {
  const [role, setRole] = useState({ kind: "company", role: "" });
  const [userId, setUserId] = useState(users[0]?.uid);
  const [usersList, setUsersList] = useState(users);

  const handleAccept = () => onAccept(userId, role.role as Role);

  useEffect(() => {
    const companyMembersIds = companyMembers?.map((member) => member.id);
    setUsersList(
      users.filter((user) => !companyMembersIds?.includes(user.uid)),
    );
  }, [role, companyMembers, users]);

  return (
    <SlideOverWrapper
      open={open}
      buttonProps={{ onClick: handleAccept, title: "Assign member" }}
      onClose={onClose}
      title="Assign new member to the company"
    >
      <div className={SLIDEOVER_EDIT_ICON_WRAPPER_STYLES}>
        <UserPlus className={SLIDEOVER_EDIT_ICON_ICON_STYLES} />
      </div>
      <NamedSelect
        title="users"
        options={[
          { title: "Select user", value: "", disabled: true },
          ...usersList.map(({ email, uid }) => ({
            title: email,
            value: uid,
          })),
        ]}
        capitalize={false}
        value={userId}
        onChange={(target) => setUserId(target.value)}
        styleVariant="detailPage"
      />

      <RoleSelect onChange={setRole} roles={companyUserRoles} />
    </SlideOverWrapper>
  );
};
